import Cookies from 'js-cookie';

import { HubspotPlatformName } from './integrations.types';
import logger from '../../../utils/logger';

export const HUBSPOT_FORM_URL =
  'https://api.hsforms.com/submissions/v3/integration/submit/6334445/6fa92536-2f08-4d51-bba5-b79cc2c974df';

export async function postInterestToHubspot({
  email,
  platform,
}: {
  email: string;
  platform: HubspotPlatformName;
}) {
  if (window.location.origin !== 'https://www.iwoca.co.uk') return; // Only submit in prod

  // Marketing telemetry. Fetch rejections are swallowed here so this never
  // throws, but a hung fetch still leaves the returned promise pending — callers
  // that navigate (Shopify "Install plugin", RegisterInterestButton) must fire it
  // with `void` and not await it, or the navigation would stall (IWPS-509).
  try {
    // eslint-disable-next-line iwoca/prefer-lapi-client
    return await fetch(HUBSPOT_FORM_URL, {
      method: 'POST',
      // Let the request outlive the page navigation it's fired alongside.
      keepalive: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      body: JSON.stringify({
        fields: [
          { name: 'email', value: email },
          { name: 'e_commerce_platform', value: platform },
        ],
        context: {
          hutk: Cookies.get('hubspotutk'),
        },
      }),
    });
  } catch (error) {
    logger.warn('Failed to post integration interest to HubSpot', { error });
  }
}
